import React, { useState, useEffect, useRef } from 'react'
import Box from '@material-ui/core/Box';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Grid from '@toast-ui/react-grid';
import SaveIcon from "@material-ui/icons/Save";
import axios from 'axios';
import moment from "moment";

const style = {
  position: 'absolute',
  top: '62%',
  left: '58%',
  transform: 'translate(-50%, -50%)',
  width: 1190,
  height: 450,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderColor: "primary.light",
  verticalAlign: "middle",
  display: "table-cell",
  // boxShadow: 20,
  p: 2, //padding 설정
};

function MaterialJajeSerche(props) {
  const [sercheDataValue, setSercheDataValue] = useState([])
  const gridRef = useRef();

  useEffect(() => {
    axios.get('/api/MaterialsList/', { params: { materialName : props.materialJajeItemSerche } })
      .then((res) => {
        setSercheDataValue(res.data);
      })
  }, [props.materialJajeItemSerche])

  const columns = [
    { name: "r_자재코드", header: "코드", align: "center", width: 60,},
    { name: "r_자재품번", header: "품번", align: "center", width: 80,},
    { name: "r_자재지출분류", header: "지출분류", align: "center", width: 80,
      renderer: {
        styles: {
          fontWeight: 'normal',
          color: '#008000',
          fontSize: '12px',
        }
      }
    },
    { name: "r_자재업체코드", header: "업체코드", align: "center", width: 80,},
    { name: "r_자재업체명", header: "업체명", align: "left", width: 130,
      renderer: {
        styles: {
          fontWeight: 'bold',
          color: '#0080ff',
          fontSize: '12px',
        }
      }
    },
    { name: "r_자재규격", header: "자재규격", align: "left", width: 200,
      renderer: {
        styles: {
          fontWeight: 'bold',
          color: '#0080ff',
          fontSize: '12px',
        }
      }
    },
    { name: "r_자재계정과목코드", header: "과목코드", align: "center", width: 70,},
    { name: "r_자재계정과목", header: "과목", align: "left", width: 85,
      renderer: {
        styles: {
          fontWeight: 'normal',
          color: '#008000',
          fontSize: '12px',
        }
      }
    },
    { name: "r_자재단위량", header: "단위량", align: "right", width: 60,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "r_자재단위", header: "단위", align: "center", width: 50,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "r_자재단가", header: "단가", align: "right", width: 60,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "r_자재수불", header: "수불", align: "center", width: 60,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "r_자재구분", header: "구분", align: "right", width: 25,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "r_등록일자", header: "일자", align: "center", width: 90,
      formatter: function (ev) {
        return `${moment(ev.value, "YYYY-MM-DD a hh:mm").format('YYMMDD HH:mm')}`
      }
    },
  ];

  const rows = sercheDataValue.map((row) => ({
    r_자재코드: row.r_자재코드,
    r_자재품번: row.r_자재품번,
    r_자재지출분류: row.r_자재지출분류,
    r_자재규격: row.r_자재규격,
    r_자재계정과목코드:row.r_자재계정과목코드,
    r_자재업체코드: row.r_자재업체코드,
    r_자재업체명: row.r_자재업체명,
    r_자재계정과목: row.r_자재계정과목,
    r_자재단위량: row.r_자재단위량,
    r_자재단위: row.r_자재단위,
    r_자재단가: row.r_자재단가,
    r_자재수불: row.r_자재수불,
    r_자재구분: row.r_자재구분,
    r_등록일자: row.r_등록일자,
  }));


  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    frozenBorder: {
      border: 'red',
    },
    outline: {
      border: '#59b9ea',
      showVerticalBorder: true,
    },
    scrollbar: {
      border: '#59b9ea',
      thumb: 'blue'
    },
    cell: {
      normal: {
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
    },
    area: {
      header: {
        border: '#59b9ea',
        // background: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //호버설정
    row: {
      hover: {
        background: 'silver'
      }
    }
  });

  //더블클릭스 수정이벤트
  const handleDbClick = (ev) => {
    var rowKey = ev.rowKey
    var DbclickValue = gridRef.current.getInstance().getRow(ev.rowKey)
    if (ev.rowKey === rowKey ) {
      props.setMaterialJajeItemSercheValue(DbclickValue);     
      props.setMaterialJajeModal(false);
    }
    else {
      console.log('작지번호 필드가 아님');
    }
  };

  return (
    <div>
      <Modal open={props.materialJajeModal}>
        <Box sx={{ ...style }}>
          <h4 id="child-modal-title" style={{color:'blue'}}>구매제품정보</h4>
          <div>
            <Grid
              columns={columns}
              data={rows}
              rowColumn={'auto'}
              scrollY={false}
              rowHeight={22} //셀높이설정
              minRowHeight={10}
              bodyHeight={300}
              header={{ height: 28 }} //Body혜드높이 설정
              heightResizable={true}
              usageStatistics={false}
              ref={gridRef}
              columnOptions={{ resizable: true }} //컬럼 넓이마우스조절됨
              onDblclick={handleDbClick}
              // onClick={handleClick}
            />
          </div>
          <Button onClick={() => { props.setMaterialJajeModal(false) }}
            variant="contained"
            startIcon={<SaveIcon />}
            style={{
              height: "30px",
              background: '#689f38',
              color: 'white',
              width: 100,
              marginTop: "2px",
              float: "center",
            }}>닫기</Button>
        </Box>
      </Modal>
    </div>
  );
}
export default MaterialJajeSerche